'use client'
import { Tabs, TabsList, TabsListProps, TabsTrigger } from '@/shared/ui/tabs'
import { TabsProps, TabsTriggerProps } from '@radix-ui/react-tabs'
import { Skeleton } from '@/shared/ui/skeleton'
import { cn } from '@/shared/lib/classnames'
import { Option } from '@/shared/lib/types/field-option'
import { SelectionDictionaryParams, dictionaryQueries } from '../../api'

export interface ComponentProps extends Omit<TabsProps, 'options'> {
  dictionary: SelectionDictionaryParams
  valueField?: string
  labelField?: string
  variant?: TabsListProps['variant']
  defaultTabsTrigger?: TabsTriggerProps
  skeletonCount?: number
}

const getSkeletons = (count: number) =>
  new Array(count).fill(0).map((item, index) => <Skeleton key={index} className={cn('w-14 h-full')} />)

export default function Component({
  labelField = 'name',
  valueField = 'id',
  variant = 'underline',
  dictionary,
  defaultTabsTrigger,
  skeletonCount,
  ...props
}: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(dictionary)

  if (isLoading)
    return (
      <Skeleton className={cn('h-10 flex justify-center items-center p-1 gap-x-2', props.className)}>
        {getSkeletons(skeletonCount || 4)}
      </Skeleton>
    )

  return (
    <Tabs
      {...props}
      defaultValue={props?.defaultValue || (data?.[0] as Option)?.[valueField]}
      className={cn('relative mr-auto w-fit', props.className)}
    >
      <TabsList variant={variant} className="w-fit">
        <TabsTrigger {...defaultTabsTrigger} variant={variant} value={defaultTabsTrigger?.value || 'default'}>
          {defaultTabsTrigger?.children || 'Все'}
        </TabsTrigger>

        {data?.map((item, index) => {
          const label = (item as Option)?.[labelField]
          const value = (item as Option)?.[valueField]

          return (
            <TabsTrigger formNoValidate key={index} variant={variant} value={String(value)}>
              {label}
            </TabsTrigger>
          )
        })}
      </TabsList>
    </Tabs>
  )
}
